var map = {
	"./app-icon.svg": "bf6a",
	"./audio.svg": "2cf7",
	"./blank.svg": "ee86",
	"./cursor.svg": "16fb",
	"./excel.svg": "faee",
	"./html.svg": "b6a4",
	"./illustrator.svg": "e3fc",
	"./image.svg": "d17f",
	"./indesign.svg": "c9fb",
	"./logo.svg": "a5f75",
	"./mail.svg": "4f1b",
	"./mindmanager.svg": "cc6e",
	"./msproject.svg": "4abe",
	"./onenote.svg": "73fd",
	"./openoffice_calc.svg": "d985",
	"./openoffice_draw.svg": "963d",
	"./openoffice_impress.svg": "1e34",
	"./openoffice_math.svg": "f473",
	"./openoffice_writer.svg": "5ad5",
	"./pdf.svg": "4e08",
	"./photoshop.svg": "c8c7",
	"./powerpoint.svg": "00ff",
	"./text.svg": "e447",
	"./video.svg": "2b54",
	"./visio.svg": "1835",
	"./word.svg": "721a",
	"./zip.svg": "b8b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";